import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import WithSidebar from 'Layout/WithSidebar';
import Banner from 'components/Banner';
import ProductSidebar from 'components/ProductSidebar';
import BenefitsCards from 'components/BenefitsCards';
import {
    fetchCropNutritionPageCrops,
    fetchCropNutritionDetail,
    selectCropNutritionDetail,
    selectCropNutritionPageCrops,
} from 'store/slices/CropNutritionSlice';
import { useParams } from 'react-router-dom';
import GeneralInfoBox from 'components/GeneralInfoBox';
import { type_nutrition } from 'api/constants';
import { ROUTES } from 'constants/routes';

const DetailedOfCropNutrition = () => {
    const dispatch = useDispatch();
    const { slug } = useParams();

    const {
        title,
        fs_view_button,
        fs_background,
        purpose_processing,
        detailed_data,
        sidebar_text,
        purposes = [],
    } = useSelector(selectCropNutritionDetail);

    const crops = useSelector(selectCropNutritionPageCrops);
    const sidebarCrops = crops.filter(item => item.slug !== slug);

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchCropNutritionPageCrops({ type: type_nutrition, all: true }));
        // @ts-ignore
        dispatch(fetchCropNutritionDetail({ slug, type: type_nutrition }));
    }, [dispatch, slug]);

    return (
        <>
            <Banner title={title} image={fs_background} buttonText={fs_view_button} />
            <section className="container">
                <WithSidebar
                    containerType="type-1"
                    mobileReversed
                    Sidebar={
                        <ProductSidebar
                            baseRoute={ROUTES.cropNutritionPrograms}
                            title={sidebar_text}
                            data={sidebarCrops}
                        />
                    }
                >
                    <GeneralInfoBox>
                        <div dangerouslySetInnerHTML={{ __html: detailed_data }} />
                        {purpose_processing && <h3>{purpose_processing}</h3>}
                        {purposes.length && <BenefitsCards data={purposes} withCustomContent />}
                    </GeneralInfoBox>
                </WithSidebar>
            </section>
        </>
    );
};

export default DetailedOfCropNutrition;
